export const USFlagRound = ({ width = "32px", height = "32px" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#a)">
          <path
            d="M6.877 29.142h18.247v-.001H6.877h.001ZM16 0c-.314 0-.626.011-.935.029h1.87C16.627.011 16.316 0 16 0Z"
            fill="#C42126"
          />
          <path
            d="M20.729 5.85h7.64a16.077 16.077 0 0 0-3.13-2.91H19.5c.475.835.883 1.82 1.228 2.91Z"
            fill="#E7E7E7"
          />
          <path
            d="M19.502 2.94h5.736A15.911 15.911 0 0 0 16.936.03h-.493c1.451.182 2.118 1.256 3.058 2.91Z"
            fill="#DC3027"
          />
          <path
            d="M31.404 11.674a15.898 15.898 0 0 0-1.135-2.91h-8.79c.178.934.319 1.91.423 2.91h9.502Z"
            fill="#E7E7E7"
          />
          <path
            d="M20.985 8.763h9.283a16.007 16.007 0 0 0-1.899-2.911h-8.11c.286.905.529 1.881.726 2.91Z"
            fill="#DC3027"
          />
          <path
            d="M22.238 17.497h9.69c.046-.493.072-.992.072-1.496 0-.477-.025-.948-.066-1.415H22.24c.032.968.031 1.943-.002 2.91Z"
            fill="#E7E7E7"
          />
          <path
            d="M31.934 14.584c-.088-1-.268-1.972-.53-2.91h-9.91c.099.953.165 1.928.197 2.91h10.243Z"
            fill="#DC3027"
          />
          <path
            d="M21.312 23.317h8.915c.475-.921.863-1.895 1.153-2.91h-9.637a34.487 34.487 0 0 1-.431 2.91Z"
            fill="#E7E7E7"
          />
          <path
            d="M31.38 20.407c.269-.938.456-1.91.548-2.91h-9.992a40.989 40.989 0 0 1-.203 2.91h9.648Z"
            fill="#DC3027"
          />
          <path
            d="M25.124 29.141a16.097 16.097 0 0 0 3.177-2.91h-7.507c-.35 1.094-.767 2.078-1.25 2.91h5.58Z"
            fill="#E7E7E7"
          />
          <path
            d="M20.512 26.23h7.79a16.023 16.023 0 0 0 1.924-2.912h-8.98c-.2 1.03-.444 2.008-.734 2.911ZM15.42 31.988l-.097-.004.097.004ZM16 32c3.392 0 6.535-1.06 9.123-2.86h-5.79C18.305 30.912 17.627 32 16 32Z"
            fill="#DC3027"
          />
          <path d="M16 32Z" fill="#C42126" />
          <path
            d="M20.031 2.94H6.761a16.082 16.082 0 0 0-3.13 2.91h17.627c-.344-1.09-.752-2.075-1.227-2.91Z"
            fill="#F3F4F5"
          />
          <path
            d="M6.762 2.94h13.27C19.09 1.287 17.894.213 16.442.03h-1.379a15.91 15.91 0 0 0-8.302 2.91Z"
            fill="#E73625"
          />
          <path
            d="M.597 11.674h21.81c-.105-1-.245-1.976-.423-2.91H1.732a15.89 15.89 0 0 0-1.135 2.91Z"
            fill="#F3F4F5"
          />
          <path
            d="M3.631 5.852a16.02 16.02 0 0 0-1.9 2.91h20.253a25.637 25.637 0 0 0-.726-2.91H3.631Z"
            fill="#E73625"
          />
          <path
            d="M0 16.001c0 .504.027 1.003.072 1.495h22.53a43.59 43.59 0 0 0 .002-2.91H.066C.026 15.053 0 15.524 0 16Z"
            fill="#F3F4F5"
          />
          <path
            d="M.066 14.584h22.538a41.057 41.057 0 0 0-.198-2.91H.596c-.262.938-.442 1.91-.53 2.91Z"
            fill="#E73625"
          />
          <path
            d="M22.398 20.406H.62c.29 1.016.678 1.99 1.153 2.911h20.194c.181-.933.325-1.91.431-2.91Z"
            fill="#F3F4F5"
          />
          <path
            d="M.62 20.407h21.778c.102-.953.17-1.928.204-2.91H.072c.093 1 .28 1.972.548 2.91Z"
            fill="#E73625"
          />
          <path
            d="M6.876 29.141h13.106c.484-.832.9-1.816 1.251-2.91H3.7a16.088 16.088 0 0 0 3.177 2.91Z"
            fill="#F3F4F5"
          />
          <path
            d="M1.774 23.318a16.029 16.029 0 0 0 1.925 2.911h17.534c.29-.903.535-1.88.734-2.91H1.774ZM15.323 31.985c.033 0 .065.002.097.003.193.007.386.011.58.011 1.627 0 2.954-1.088 3.982-2.858H6.877a15.916 15.916 0 0 0 8.446 2.844Z"
            fill="#E73625"
          />
          <path
            d="M15.67.008C7.47.175.786 6.505.067 14.558H15.67V.008Z"
            fill="#283991"
          />
          <path
            d="m3.202 9.066.243.751h.79l-.639.464.244.751-.638-.464-.639.464.244-.75-.639-.465h.79l.244-.75ZM3.202 11.717l.243.75h.79l-.639.465.244.751-.638-.464-.639.464.244-.751-.639-.464h.79l.244-.751ZM5.854 5.088l.243.75h.79l-.639.465.244.75-.638-.463-.639.464.244-.75-.64-.465h.79l.245-.751ZM5.854 7.74l.243.751h.79l-.639.464.244.751-.638-.464-.639.464.244-.751-.64-.464h.79l.245-.75ZM5.854 10.39l.243.752h.79l-.639.463.244.751-.638-.464-.639.464.244-.75-.64-.464h.79l.245-.751ZM1.188 12.358l-.244-.752.639-.463h-.79l-.017-.055c-.087.268-.165.54-.237.814l.01-.009.64.465ZM2.563 8.38l.639-.464.638.464-.244-.751.639-.464h-.79l-.244-.75-.244.75h-.29c-.055.081-.107.164-.16.247l.3.217-.244.751ZM5.854 3.937l.638.463-.244-.75.639-.464H6.43c-.387.29-.761.596-1.12.919l-.096.295.639-.463ZM7.867 3.076l.639-.465.638.465-.244-.751.639-.464h-.79l-.033-.101a15.82 15.82 0 0 0-.79.43l.185.135-.244.75ZM8.506 3.762l.244.75h.79l-.64.464.244.751-.638-.464-.639.464.244-.75-.639-.465h.79l.244-.75ZM8.506 6.414l.244.75h.79l-.64.465.244.75-.638-.464-.639.465.244-.751-.639-.465h.79l.244-.75ZM8.506 9.066l.244.751h.79l-.64.464.244.751-.638-.464-.639.464.244-.75-.639-.465h.79l.244-.75ZM8.506 11.717l.244.75h.79l-.64.465.244.751-.638-.464-.639.464.244-.751-.639-.464h.79l.244-.751ZM11.158 2.436l.244.75h.79l-.64.465.244.75-.638-.464-.639.464.244-.75-.639-.465h.79l.244-.75ZM11.158 5.088l.244.75h.79l-.64.465.244.75-.638-.463-.639.464.244-.75-.639-.465h.79l.244-.751ZM11.158 7.74l.244.751h.79l-.64.464.244.751-.638-.464-.639.464.244-.751-.639-.464h.79l.244-.75ZM11.158 10.39l.244.752h.79l-.64.463.244.751-.638-.464-.639.464.244-.75-.639-.464h.79l.244-.751ZM13.81 1.11l.244.75h.79l-.64.464.244.751-.638-.464-.639.464.244-.751-.639-.464h.79l.244-.75ZM13.81 3.762l.244.75h.79l-.64.464.244.751-.638-.464-.639.464.244-.75-.639-.465h.79l.244-.75ZM13.81 6.414l.244.75h.79l-.64.465.244.75-.638-.464-.639.465.244-.751-.639-.465h.79l.244-.75ZM13.81 9.066l.244.751h.79l-.64.464.244.751-.638-.464-.639.464.244-.75-.639-.465h.79l.244-.75ZM13.81 11.717l.244.75h.79l-.64.465.244.751-.638-.464-.639.464.244-.751-.639-.464h.79l.244-.751Z"
            fill="#EFEFEF"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
